/* Discount code form and order limit for the /cart page. The drawer has its own version in eggo-cart.js. */
import {EVENT_CART_PAGE_RENDERED} from "./eggo-cart-events";
import {checkOrderLimit} from "./eggo-cart-limit";

const FOOTER = "#main-cart-footer";
let busy = false;

const getAppliedCodes = () => {
    return [...document.querySelectorAll(`${FOOTER} .eggo-discount-tag`)].map((tag) => tag.dataset.discountCode);
}

const hasAppliedCode = (code) => {
    return getAppliedCodes().some((applied) => applied.toLowerCase() === code.toLowerCase());
}

const refreshOrderLimit = () => {
    const totals = document.querySelector(`${FOOTER} .eggo-cart-totals`);
    if (!totals) return;
    checkOrderLimit(parseInt(totals.dataset.cartTotal) / 100);
}

const getSectionInnerHTML = (html, selector) => {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
}

/** Sets the discount codes on the cart and re-renders the same sections assets/cart.js re-renders. */
const updateDiscounts = async (codes) => {
    const sections = [
        {id: "main-cart-items", section: document.getElementById("main-cart-items").dataset.id, selector: ".js-contents"},
        {id: "cart-icon-bubble", section: "cart-icon-bubble", selector: ".shopify-section"},
        {id: "main-cart-footer", section: document.getElementById("main-cart-footer").dataset.id, selector: ".js-contents"},
    ];
    const response = await fetch(`${routes.cart_update_url}.js`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
            discount: codes.join(","),
            sections: sections.map((section) => section.section),
            sections_url: window.location.pathname
        })
    });
    const state = await response.json();
    sections.forEach((section) => {
        const wrapper = document.getElementById(section.id);
        const target = wrapper.querySelector(section.selector) || wrapper;
        target.innerHTML = getSectionInnerHTML(state.sections[section.section], section.selector);
    });
    refreshOrderLimit();
}

const showError = (code) => {
    const error = document.querySelector(`${FOOTER} .eggo-discount-form__error`);
    const input = document.querySelector(`${FOOTER} .eggo-discount-form__input`);
    if (!error || !input) return;
    input.value = code;
    error.hidden = false;
}

const applyCode = async (code) => {
    const previous = getAppliedCodes();
    const codes = hasAppliedCode(code) ? previous : [...previous, code];
    await updateDiscounts(codes);
    if (hasAppliedCode(code)) return;
    /** A code that did not turn into a visible discount is not usable in the cart: take it out again and tell the customer. */
    await updateDiscounts(previous);
    showError(code);
}

const removeCode = async (code) => {
    await updateDiscounts(getAppliedCodes().filter((applied) => applied !== code));
}

const runExclusive = async (action) => {
    if (busy) return;
    busy = true;
    try {
        await action();
    } catch (error) {
        console.error(error);
        window.location = routes.cart_url;
    } finally {
        busy = false;
    }
}

document.addEventListener("DOMContentLoaded", function () {
    if (!document.querySelector(FOOTER)) return;
    refreshOrderLimit();
    document.addEventListener(EVENT_CART_PAGE_RENDERED, refreshOrderLimit);

    document.addEventListener("submit", (event) => {
        const form = event.target.closest(`${FOOTER} .eggo-discount-form`);
        if (!form) return;
        event.preventDefault();
        const code = form.querySelector(".eggo-discount-form__input").value.trim();
        if (code) runExclusive(() => applyCode(code));
    });

    document.addEventListener("click", (event) => {
        const removeButton = event.target.closest(`${FOOTER} .eggo-discount-tag__remove`);
        if (!removeButton) return;
        runExclusive(() => removeCode(removeButton.closest(".eggo-discount-tag").dataset.discountCode));
    });
});
